import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { SIGNUP_URL } from './config/links';

import App from './App';
import Guide from './pages/guide/Guide'
import Schedule from './pages/schedule/Schedule'
import Faq from './pages/faq/Faq'

import './index.css';

import {
    createBrowserRouter,
    RouterProvider,
  } from "react-router-dom";

const Media = lazy(() => import('./pages/media/Media'));
const Bestofnest = lazy(() => import('./pages/media/events/bestofnest/Bestofnest'));
const Mmhc = lazy(() => import('./pages/media/events/mmhc/Mmhc'));
const Aiyara = lazy(() => import('./pages/media/events/aiyara/Aiyara'));
const Firstweek = lazy(() => import('./pages/media/events/firstweek/Firstweek'));

  const router = createBrowserRouter([
    {
      path: "/",
      element: <App/>,
    },
    {
        path: "/Muaythai-Guide",
        element: <Guide/>,
    },

    {
      path:"/Schedule-and-Fees",
      element: <Schedule/>,
    },

    {
      path:"/Free-Trial",
      loader: () => { window.location.replace(SIGNUP_URL); return null; },
    },

    {
      path:"/Join-Us",
      loader: () => { window.location.replace(SIGNUP_URL); return null; },
    },
    {
      path:"/Faq",
      element: <Faq standalone/>,
    },
    {
      path: "/Media",
      element: <Media/>
    },
    {
      path:"/Best-of-the-Nest",
      element: <Bestofnest/>
    },
    {
      path:"/Mens-Mental-Health-Collab",
      element: <Mmhc/>
    },
    {
      path:"/Thai-Aiyara-Collab",
      element: <Aiyara/>
    },

    {
      path:"/Firstweek",
      element: <Firstweek/>
    }

  ]);

  ReactDOM.createRoot(document.getElementById("root")).render(
    <Suspense fallback={<p role="status" style={{padding: "2rem"}}>Loading page…</p>}><RouterProvider router={router} /></Suspense>
);
